import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Ok, I understand',
    description:
      'We are sorry for this and are doing everything we can to allow companies like yours to join us in the future.',
    title: 'Your company is not eligible to open a Shine account',
  },
  fr: {
    cta: 'Ok, c’est compris',
    description:
      'Nous en sommes désolés et mettons tout en œuvre pour permettre aux entreprises comme la vôtre de nous rejoindre à l’avenir.',
    title:
      'Votre entreprise n’est pas éligible à l’ouverture d’un compte Shine',
  },
} as const);
